import React, { useState } from "react";

import { CiCircleChevLeft } from "react-icons/ci";

import { profileBuilder, Spacer } from "../../components";

const StudentProfileBuilder = () => {
  const [page, setPage] = useState("Profile Builder");

  return (
    <div className="text-black">
      <div className="header-md pl-2 flex gap-2 items-center">
        {page !== "Profile Builder" && (
          <CiCircleChevLeft
            className="h-[1.5em] w-[1.5em]"
            onClick={() => setPage("Profile Builder")}
          />
        )}
        {page}
      </div>
      <Spacer height="0.625em" />
      {page === "Academics" ? (
        <profileBuilder.Academics setPage={setPage} />
      ) : page === "Extra-Curricular Activities" ? (
        <profileBuilder.Activities setPage={setPage} />
      ) : page === "Address" ? (
        <profileBuilder.Address setPage={setPage} />
      ) : page === "Emergency Contact" ? (
        <profileBuilder.ContactProfileBuilder setPage={setPage} />
      ) : page === "Counselor" ? (
        <profileBuilder.Counselor setPage={setPage} />
      ) : page === "Demographics" ? (
        <profileBuilder.Demographics setPage={setPage} />
      ) : page === "Education" ? (
        <profileBuilder.Education setPage={setPage} />
      ) : page === "Facilities" ? (
        <profileBuilder.Facilities setPage={setPage} />
      ) : page === "Financial" ? (
        <profileBuilder.Financial setPage={setPage} />
      ) : page === "General Information" ? (
        <profileBuilder.GeneralInfo setPage={setPage} />
      ) : page === "High School Grades" ? (
        <profileBuilder.HighSchoolGrades setPage={setPage} />
      ) : page === "Location" ? (
        <profileBuilder.Location setPage={setPage} />
      ) : page === "Others" ? (
        <profileBuilder.Others setPage={setPage} />
      ) : page === "People" ? (
        <profileBuilder.People setPage={setPage} />
      ) : page === "Test Scores" ? (
        <profileBuilder.TestScores setPage={setPage} />
      ) : (
        <profileBuilder.ProfileBuilder setPage={setPage} />
      )}
    </div>
  );
};

export default StudentProfileBuilder;
